import { useBookingQuery } from 'app/containers/rtc/BookingContext/BookingQueryContext';
import { useBookingState } from 'app/containers/rtc/BookingContext/BookingState';


/**
 * A crude helper that is used to determine whether the booking state should be loading.
 * This only works during the bootstrapping phase of the application and is not reliable for
 * loading events that are not contingent on initial page load.
 *
 * This likely can be removed with the introduction of:  https://github.com/iknow/issues/issues/214.
 */
const useIsBookingInitiallyLoading = (): boolean => {
  const [bookingQuery] = useBookingQuery();
  const bookingState = useBookingState();

  // If the booking query shows that there are booking parameters but they don't reflect the booking state
  // then it likely means the booking state has not been loaded, yet.
  return 'bookingId' in bookingQuery && bookingQuery.bookingId !== bookingState?.bookingId &&
    'bookingType' in bookingQuery && bookingQuery.bookingType !== bookingState?.bookingType;
};

export default useIsBookingInitiallyLoading;
